import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import store from "./store";
import "./registerServiceWorker";

// Importe a função de iniciar o banco
import { iniciarBancoDados } from "./db/db"; 

import "@/plugins/mq";
import "@/plugins/axios";
import "@/plugins/toasted";
import "@/plugins/mask";

Vue.config.productionTip = false;

// Envolvemos a inicialização numa função async
async function startApp() {
  
  try {
    // 1. O código PARA aqui e espera o IndexedDB criar as tabelas (usuario-logado, etc)
    // Isso garante que quando o Router rodar, o banco já existe.
    await iniciarBancoDados();
    console.log("Banco de dados carregado com sucesso.");
  } catch (error) {
    console.error("Erro crítico ao iniciar banco de dados:", error);
    // Opcional: Mostrar um alert ou redirecionar para página de erro estática
  }

  // 2. Só AGORA iniciamos o Vue e o Router
  new Vue({
    router,
    vuetify,
    store,
    render: (h) => h(App),
  }).$mount("#app");
}

// Chama a função para rodar o sistema
startApp();